import Vue from 'vue'
import Router from 'vue-router'
import shujufenxi from '@/components/shujufenxi'
import yingyebaobiao from '@/components/yingyebaobiao'
import xiaoshoubaobiao from '@/components/xiaoshoubaobiao'
import caigoubaobiao from '@/components/caigoubaobiao'
import kucunbaobiao from '@/components/kucunbaobiao'
import kehubaobiao from '@/components/kehubaobiao'
import caiwubaobiao from '@/components/caiwubaobiao'
import yingxiaobaobiao from '@/components/yingxiaobaobiao'

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/',
      name: 'shujufenxi',
      component: shujufenxi,
			meta: {
				title:'数据分析',
			}
    },
    {
      path: '/yingyebaobiao',
      name: 'yingyebaobiao',
      component: yingyebaobiao,
			meta: {
				title:'营业报表',
			}
    },
    {
      path: '/xiaoshoubaobiao',
      name: 'xiaoshoubaobiao',
      component: xiaoshoubaobiao,
			meta: {
				title:'销售报表',
			}
    },
    {
      path: '/caigoubaobiao',
      name: 'caigoubaobiao',
      component: caigoubaobiao,
			meta: {
				title:'采购报表',
			}
    },
    {
      path: '/kucunbaobiao',
      name: 'kucunbaobiao',
      component: kucunbaobiao,
			meta: {
				title:'库存报表',
			}
    },
    {
      path: '/kehubaobiao',
      name: 'kehubaobiao',
      component: kehubaobiao,
			meta: {
				title:'客户报表',
			}
    },
    {
      path: '/caiwubaobiao',
      name: 'caiwubaobiao',
      component: caiwubaobiao,
			meta: {
				title:'财务报表',
			}
    },
    {
      path: '/yingxiaobaobiao',
      name: 'yingxiaobaobiao',
      component: yingxiaobaobiao,
			meta: {
				title:'营销报表',
			}
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js